import './ActionButtons.scss'
import { get } from 'svelte/store';
import { _ } from 'svelte-i18n';

type ActionButtonsCallbacks = {
  onAddAll: () => void,
}

export class ActionButtons {
  
  private readonly root: HTMLDivElement;
  private readonly callbacks: ActionButtonsCallbacks;
  private readonly enableAddAll: boolean;
  
  constructor(root: HTMLDivElement, enableAddAll: boolean, callbacks: ActionButtonsCallbacks) {
    this.root = root;
    this.callbacks = callbacks;
    this.enableAddAll = enableAddAll;
    this.render();
  }
  
  private render(): void {
    this.root.innerHTML = this.getHTML();
    
    if (this.enableAddAll) {
      this.root.querySelector('.action-button--add-all').addEventListener('click', () => {
        this.callbacks.onAddAll();
      });
    } else {
      this.root.querySelector('.action-button--add-all').remove();
    }
    
    // this.hideMaxAllowedSelectedItemsMessage();
  }
  
  public showSelectedCounter(count: number, max: number, forceDisplay: boolean = false): void {
    if (!this.enableAddAll || forceDisplay) {
      this.root.querySelector('.caption').innerHTML = get(_)('Selected: {count} of {max} possible', { values: { count: count, max: max } });
    }
  }
  
  // public showMaxAllowedSelectedItemsMessage(): void {
  //   this.root.querySelector('.max-allowed-selected-items-message').classList.add('visible');
  //   this.root.querySelector('.caption').classList.add('hidden');
  // }
  //
  // public hideMaxAllowedSelectedItemsMessage(): void {
  //     this.root.querySelector('.max-allowed-selected-items-message').classList.add('hidden');
  //     this.root.querySelector('.caption').classList.add('visible');
  // }
  //
  private getHTML(): string {
    return `
      <div class="action-buttons-container">
          <div class="caption">${get(_)('Selected:')}</div>
<!--          <div class="max-allowed-selected-items-message">Wybrano maksymalną liczbę</div>-->
          <button class="action-button action-button--add-all">${get(_)('(add all)')}</button>
      </div>
    `;
  }
  
}
